import { css, html, LitElement, PropertyValues } from 'lit';

const NAME = 'afs-component';

class AfsComponent extends LitElement {
  className: '';

  static get properties() {
    return {
      className: { type: String }
    };
  }

  constructor() {
    super();
    this.className = ''; // TODO: this to be rename to placementId
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  private makeSlotAvailableFromLightDOM() {
    if (this.querySelector(`#${this.className}`)) {
      // If the container is already in the surrounding DOM, do nothing. This
      // check makes the component backwards compatible when the slotted
      // container is added by the component user.
      //
      // This is necessary because the component is used in two ways:
      // 1. The component user adds the container to the light DOM. This is the
      //    recommended way of using the component. One reason for this is to avoid
      //    hydration mismatch issues when using the component with React SSR.
      // 2. The component user does not add the container to the light DOM.
      //    This is the legacy way of using the component. The component adds the
      //    container to the light DOM itself, in order to be backwards compatible.
      return;
    }

    const slotDiv = document.createElement('div');
    slotDiv.slot = `${this.className}--slot`;
    slotDiv.id = this.className;

    // add the div with slot available in the light DOM
    this.appendChild(slotDiv);
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.makeSlotAvailableFromLightDOM();
  }

  static styles = css`
    :host {
      margin: 0 auto;
      overflow: hidden;
      grid-column: 1 / -1;
      width: 100%;
      min-height: 10px;
    }
  `;

  render() {
    return html`
      <slot name="${`${this.className}--slot`}" id="${this.className}"></slot>
    `;
  }
}

export function defineAfsComponent() {
  if (!customElements.get(NAME)) {
    customElements.define(NAME, AfsComponent);
  }
}
